const config = {
  server_url: 'https://knalbak.nl/',
};
export default config;